/**
 * @fileoverview The purpose of this component is to ensure campaign data is
 * loaded before rendering children
 */
import { useState } from 'react'
import { connect } from 'react-redux'
import { getCampaignById } from './../../../Reducers/Campaigns/actions'

const CampaignDataHOC = props => {
  const [isFetched, setIsFetched] = useState(false)
  const [isFetching, setIsFetching] = useState(false)

  if (isFetching) return null

  if (!isFetched) {
    setIsFetching(true)
    props.getCampaignById(props.campaignId).then(() => {
      setIsFetched(true)
      setIsFetching(false)
    })
    return null
  }
  return props.children
}

export default connect(
  null,
  { getCampaignById },
)(CampaignDataHOC)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/DataHOC/index.js